import type { CompanyRole } from '@/features/permissions/domain/permission'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { User, UserPort } from '../domain/user'

type CreateUserInput = {
	fullName: string
	email: string
	companyRole: CompanyRole
}

const createUser = async (port: UserPort, data: CreateUserInput, notify: NotifyPort): Promise<User> => {
	try {
		const user = await port.create(data)
		notify.success('member.added')
		return user
	} catch {
		notify.error('member.addFailed')
		throw new Error('Failed to add member.')
	}
}

export type { CreateUserInput }
export { createUser }
